import React from "react";
import PropTypes from "prop-types";
import useTabs from "../../hooks/useTabs";

import "./VerticalTabs.scss";

function VerticalTabs({
  tabs,
  tabIdAccessor,
  targetPanelIdAccessor,
  defaultTabId,
  titleRenderer = (tab) => tab.title,
  contentRenderer = (tab) => tab.content,
}) {

  const {
    tabs:tablist,
    activeTab,
    getContainerProps,
    getTabProps,
    getPanelProps,
  } = useTabs({
    tabs, tabIdAccessor, targetPanelIdAccessor, defaultTabId
  })

  return (
    <div className="vertical-tabs-container" {...getContainerProps}>
      <div className="pe-md-3 px-0 navigation-tabs-container">
        <ul className="nav flex-column vertical-tabs" id="vertical-nav-tab">
          {
            tablist.map(tab => (
              <li className="nav-item" key={tab[tabIdAccessor]} {...getTabProps(tab[tabIdAccessor])}>
                <span className={`nav-link text-dark ${tab.decoratorClass} ${activeTab === tab[tabIdAccessor] ? 'active': ''}`}>
                  { titleRenderer(tab) }
                </span>
              </li>
            ))
          }
        </ul>
      </div>
      <div className="px-md-3 px-0 tab-content-container">
        <div className="tab-content" id="v-pills-tabContent">
          {
            tablist.map(tab => (
              <div className={`tab-pane ${ activeTab === tab[tabIdAccessor] ? 'show active' : 'fade'}`} {...getPanelProps(tab[tabIdAccessor])}>
                { contentRenderer(tab) }
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

VerticalTabs.defaultProps = {};

VerticalTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabIdAccessor: PropTypes.string.isRequired,
  targetPanelIdAccessor: PropTypes.string.isRequired,
  defaultTabId: PropTypes.string.isRequired,
  titleRenderer: PropTypes.func,
  contentRenderer: PropTypes.func,
};

export default VerticalTabs;